import React from 'react'
import './footer.css'
import { RiFacebookBoxFill } from 'react-icons/ri'
import facebook from '../assets/facebook.png'
import twitter from '../assets/twitter.png'
import linkedin from '../assets/linkedin.png'
const Footer = () => {
  return (
    <footer>
      <a href='#' className='footer__logo'>Afrinovator</a>
      <ul className='permalinks'>
        <li><a href="#">Home</a></li>
        <li><a href="#About">About</a></li>
        <li><a href="#Services">Services</a></li>
        <li><a href="#Experience">Experience</a></li>
        {/* <li><a href="#portfolio">Portfolio</a></li> */}
        {/* <li><a href="#testimonials">Testimonials</a></li> */}
        <li><a href="#Contact">Contact</a></li>
      </ul>
      <ul className='footer-socials'>
        <li><a href="#"><img src={linkedin} alt="linkedIn Icon" /></a></li>
        <li><a href="#"><img src={twitter} alt="twitter Icon" /></a></li>
        <li><a href="#"><img src={facebook} alt="facebook Icon" /></a></li>
      </ul>
      <div className='footer__copyright'>

        <small>&copy;Afrinovator. All rights reserved @2024</small>
      </div>


    </footer>

  )
}

export default Footer